<template>
  <div class="hub-running-waiting">
    <img src="../../../assets/img-v2/ic_running_clock.png" class="icon" />
    <div class="right">
      <div class="row">
        <div v-html="hubStatusText" class="title"></div>
        <div v-if="countdownTime && hubDriverWaitLeftTimeDesc > 0" class="countdown">
          <span>倒计时</span>
          <span class="time">{{ countdownTime }}</span>
        </div>
      </div>
      <div v-html="hubStatusDesc" class="desc"></div>
    </div>
  </div>
</template>

<script>
import { CountDown } from "@/utils/countdown";

export default {
  props: {
    orderInfo: {
      type: Object,
    },
  },
  data() {
    return {
      countdownMgr: new CountDown((time) => this.setTime(time)),
      countdownTime: "",
    };
  },
  computed: {
    hubStatusText() {
      let { hubStatusText } = this.orderInfo || {};
      return hubStatusText;
    },
    hubStatusDesc() {
      let { hubStatusDesc } = this.orderInfo || {};
      return hubStatusDesc;
    },
    hubDriverWaitLeftTimeDesc() {
      const { hubDriverWaitLeftTimeDesc } = this.orderInfo || {};
      return hubDriverWaitLeftTimeDesc;
    },
  },
  watch: {
    hubDriverWaitLeftTimeDesc: {
      immediate: true,
      handler(val) {
        if (val) {
          this.countdownMgr.start(val, true);
        } else {
          this.countdownMgr.stop();
          if (val === 0) {
            this.setTime("00:00");
          } else {
            this.setTime("");
          }
        }
      },
    },
  },
  destroyed() {
    this.countdownMgr.stop();
  },
  methods: {
    setTime(time) {
      this.countdownTime = time;
    },
  },
};
</script>

<style lang="scss" scoped>
.hub-running-waiting {
  display: flex;
  justify-content: space-between;
  padding: 13px 6px;
  .right {
    flex: 1;
    margin-left: 4px;
  }

  .row {
    display: flex;
    align-items: center;
  }
  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #000000;
    line-height: 25px;
    padding-top: 6px;

    ::v-deep .subtitle {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #000000;
      line-height: 20px;
      margin-left: 7px;
    }

    ::v-deep .blue {
      font-family: DINAlternate, DINAlternate;
      font-weight: 500;
      font-size: 24px;
      color: #006efa;
      line-height: 28px;
    }
  }

  .desc {
    font-family: PingFangSC, PingFang SC;
    font-size: 11px;
    color: #00000099;
    line-height: 16px;
    margin-top: 3px;
    ::v-deep .blue {
      color: #006efa;
      font-weight: 500;
    }
  }

  .icon {
    width: 54px;
    height: 54px;
  }

  .countdown {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    margin-left: 7px;
  }
  .time {
    font-family: DINAlternate, DINAlternate;
    font-weight: bold;
    font-size: 24px;
    color: #006efa;
    line-height: 28px;
  }
}
</style>
